var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog-shade-mod-point"},[_c('div',{staticClass:"update-dialog-mod-point"},[_c('p',[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),_c('button',{staticClass:"ui-button primary-button short-button",attrs:{"id":"cancle-button"},on:{"click":_vm.cancleUpdate}},[_vm._v(_vm._s(_vm.$t('dialog.ok')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ae3097a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/basic/pointDialog.vue
// module id = null
// module chunks = 